import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=5ba75132&scoped=true&"
import script from "./Review.vue?vue&type=script&lang=ts&"
export * from "./Review.vue?vue&type=script&lang=ts&"
import style0 from "./Review.vue?vue&type=style&index=0&id=5ba75132&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba75132",
  null
  
)

export default component.exports